/**
 * Header
 * - Adds `.shrink` to `.container-nav` on scroll (>10px) to trigger the
 *   container max-width + logo width collapse animation.
 * - Toggles the mobile menu via the burger button.
 */
export function header() {
  const container = document.querySelector('.container-nav');
  if ( ! container ) return;

  const updateNav = () => {
    if ( window.scrollY > 10 ) {
      container.classList.add('shrink');
    } else {
      container.classList.remove('shrink');
    }
  };

  updateNav();

  window.addEventListener('scroll', () => {
    window.requestAnimationFrame(updateNav);
  }, { passive: true });

  const headerEl = document.querySelector('.header');
  const burger = document.querySelector('.menu-button');

  if ( headerEl && burger ) {
    const setOpen = ( open ) => {
      headerEl.classList.toggle('nav-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    };

    burger.addEventListener('click', () => {
      setOpen( ! headerEl.classList.contains('nav-open') );
    });

    // Close the mobile menu when any in-page anchor (nav links or the CTA
    // button) is clicked, before the browser scrolls to the target.
    headerEl.querySelectorAll('a[href^="#"]').forEach( ( link ) => {
      link.addEventListener('click', () => setOpen( false ));
    });

    document.addEventListener('keydown', ( e ) => {
      if ( e.key === 'Escape' ) setOpen( false );
    });
  }
}
